export default {"src":"/_next/static/media/house-painting.e5919cc9.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};